export default __webpack_public_path__ + "static/media/enchanted-desktop.9dfa7695.mp4";